var locale = {
    placeholder: 'Select time'
};
export default locale;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/antd/es/time-picker/locale/en_US.js
// module id = null
// module chunks = 